import { Grid } from '@mui/material'
import FormInput from 'components/FormInput'
import FormControlRadio from 'components/FormControlRadio'
import { Box } from '@mui/system'
import Label from 'components/Label'
import React, { useEffect, useState } from 'react'
import { useFormContext } from 'react-hook-form'

export const familiaAcompanhaOutroServicoOptions = [
  { label: 'PAIF', value: 'PAIF' },
  { label: 'Serviço de Acolhimento', value: 'SERVICO_ACOLHIMENTO' },
  { label: 'Conselho Tutelar', value: 'CONSELHO_TUTELAR' },
  { label: 'PAEFI', value: 'PAEFI' },
  { label: 'Outro', value: 'OUTRO' },
]

const simNaoOptions = [
  {
    label: 'Sim',
    value: 'S',
  },
  {
    label: 'Não',
    value: 'N',
  },
]

interface SocialAssistanceNetworkProps {
  control: any
  doNotHasEditPermission: boolean
  watch: (name: (value: any) => void) => any
}

const SocialAssistanceNetwork: React.FC<SocialAssistanceNetworkProps> = ({
  control,
  doNotHasEditPermission,
  watch,
}) => {
  const { setValue } = useFormContext()

  const [isParticipaProjetoSocial, setIsParticipaProjetoSocial] = useState<boolean | null>(null)
  const [isFamiliaAtendidaOutroProSocial, setIsFamiliaAtendidaOutroProSocial] = useState<
    boolean | null
  >(null)

  useEffect(() => {
    const subscription = watch((value) => {
      const parseStringToBoolean = (val: string) => {
        if (val === 'S') return true
        if (val === 'N') return false
        return null
      }

      setIsParticipaProjetoSocial(
        parseStringToBoolean(
          value.meioAbertoAcompInfoRedeSocioassistencial?.participaProjetosSociais,
        ),
      )
      setIsFamiliaAtendidaOutroProSocial(
        parseStringToBoolean(
          value.meioAbertoAcompInfoRedeSocioassistencial?.familiaAtendidaOutroProgSociais,
        ),
      )
    })
    return () => subscription.unsubscribe()
  }, [watch])

  useEffect(() => {
    if (!isParticipaProjetoSocial) {
      setValue('meioAbertoAcompInfoRedeSocioassistencial.atividadeProjetoSocial', null)
    }
  }, [isParticipaProjetoSocial])

  useEffect(() => {
    if (!isFamiliaAtendidaOutroProSocial) {
      setValue('meioAbertoAcompInfoRedeSocioassistencial.programaOuBeneficiosSociais', null)
    }
  }, [isFamiliaAtendidaOutroProSocial])
  return (
    <Grid container item xs={12} spacing={2}>
      <Grid container item xs={12} spacing={2}>
        <Grid item md={12} xs={12}>
          <Box display={'flex'} flexDirection={'column'} gap={1}>
            <Label text={'CRAS de Referência:'} sx={{ fontSize: 14, color: 'text.primary' }} />
            <FormInput
              name='meioAbertoAcompInfoRedeSocioassistencial.crasReferencia'
              control={control}
              multiline
              minRows={2}
              disabled={doNotHasEditPermission}
            />
          </Box>
        </Grid>
      </Grid>
      <Grid container item xs={12} spacing={2}>
        <Grid item md={12} xs={12}>
          <FormControlRadio
            control={control}
            name='meioAbertoAcompInfoRedeSocioassistencial.participaServConvFortaleciementoVinculo'
            label='Participação no Serviço de Convivência e Fortalecimento de Vínculos?'
            options={simNaoOptions}
            disabled={doNotHasEditPermission}
          />
        </Grid>
      </Grid>
      <Grid container item xs={12} spacing={2}>
        <Grid item md={5} xs={12}>
          <FormControlRadio
            control={control}
            name='meioAbertoAcompInfoRedeSocioassistencial.participaProjetosSociais'
            label='Participação em projetos sociais de Organizações da Sociedade Civil?'
            options={simNaoOptions}
            disabled={doNotHasEditPermission}
          />
        </Grid>
        {isParticipaProjetoSocial && (
          <>
            <Grid item md={7} xs={12}>
              <FormInput
                name='meioAbertoAcompInfoRedeSocioassistencial.atividadeProjetoSocial'
                label='Onde e qual atividade?'
                control={control}
                disabled={doNotHasEditPermission}
              />
            </Grid>
          </>
        )}
      </Grid>
      <Grid container item xs={12} spacing={2}>
        <Grid item md={12} xs={12}>
          <FormControlRadio
            control={control}
            name='meioAbertoAcompInfoRedeSocioassistencial.familiaAcompanhaOutroServico'
            setValue={setValue}
            label='Família acompanhada em algum outro serviço?'
            options={familiaAcompanhaOutroServicoOptions}
            disabled={doNotHasEditPermission}
          />
        </Grid>
      </Grid>
      <Grid container item xs={12} spacing={2}>
        <Grid item md={12} xs={12}>
          <FormControlRadio
            control={control}
            name='meioAbertoAcompInfoRedeSocioassistencial.familiaInseridaCadUnico'
            label='Família inserida no Cad Único?'
            options={simNaoOptions}
            disabled={doNotHasEditPermission}
          />
        </Grid>
      </Grid>
      <Grid container item xs={12} spacing={2}>
        <Grid item md={12} xs={12}>
          <FormControlRadio
            control={control}
            name='meioAbertoAcompInfoRedeSocioassistencial.familiaBeneProgTransfRendaFederal'
            label='Família beneficiária do Programa de Transferência de Renda do Governo Federal?'
            options={simNaoOptions}
            disabled={doNotHasEditPermission}
          />
        </Grid>
      </Grid>
      <Grid container item xs={12} spacing={2}>
        <Grid item md={12} xs={12}>
          <FormControlRadio
            control={control}
            name='meioAbertoAcompInfoRedeSocioassistencial.adolescenteBeneBPC'
            label='Adolescente/Jovem beneficiário do BPC?'
            options={simNaoOptions}
            disabled={doNotHasEditPermission}
          />
        </Grid>
      </Grid>
      <Grid container item xs={12} spacing={2}>
        <Grid item md={5} xs={12}>
          <FormControlRadio
            control={control}
            name='meioAbertoAcompInfoRedeSocioassistencial.familiaAtendidaOutroProgSociais'
            label='Família atendida em outros programas ou ações de benefícios sociais?'
            options={simNaoOptions}
            disabled={doNotHasEditPermission}
          />
        </Grid>
        {isFamiliaAtendidaOutroProSocial && (
          <>
            <Grid item md={7} xs={12}>
              <FormInput
                name='meioAbertoAcompInfoRedeSocioassistencial.programaOuBeneficiosSociais'
                label='Se sim, qual?'
                control={control}
                disabled={doNotHasEditPermission}
              />
            </Grid>
          </>
        )}
      </Grid>
    </Grid>
  )
}

export default SocialAssistanceNetwork
